import UploadPhotos from './UploadPhotos';
export default UploadPhotos;